import React from "react";
import { Link } from "react-router-dom";

function Activity() {
  return (
    <div className="col-12 col-sm-6 col-md-6 col-xl-3 grid-margin stretch-card">
      <div className={`card side-edge-success`}>
        <div className="card-body">
          <div className="d-flex justify-content-between">
            <h4 className="card-title">
              Activity
              <p className="font-weight-medium text-dark text-small">
                Ver ingles
              </p>
            </h4>
            <div className="dropdown">
              <Link to="/rate/1" className="text-primary">
                <button type="button" className="btn btn-success">
                  Calificar
                </button>
              </Link>
            </div>
          </div>
          <div className="row pt-3 mt-md-1 border-top">
            <div className="col">
              <div className="d-flex purchase-detail-legend align-items-center">
                <div>
                  <p className="font-weight-medium text-dark text-small">
                    Fecha
                  </p>
                  <h3 className="font-weight-bold text-dark  mb-0">
                    18-04-2023 6:00 pm
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export { Activity };
